<template>
  <section class="full-banner-view" id="home">
    <div :class="'full-banner-' + baseLocale">
      <div class="container">
        <div class="banner-height">
          <div class="row featurette banner-text">
            <div class="col-md-6">
              <h2 class="featurette-heading">
                <span class="text-muted"></span>
              </h2>
              <div class="heading-title">{{$t("banner.heading")}}</div>
              <div
                class="heading-title-default"
              >{{$t("banner.sub_heading", {kw: $route.query.kw ? $route.query.kw : kw})}}</div>
              <ul class="features">
                <li>{{$t("banner.list.one")}}</li>
                <li>{{$t("banner.list.two")}}</li>
                <li>{{$t("banner.list.three")}}</li>
              </ul>
              <div
                class="features-details"
              >{{$t("banner.paragraph", {kw: $route.query.kw ? $route.query.kw : kw})}}</div>
              <a
                :href="'https://' + editorUrl + '/new/' + (productDetail !== null ? '?productType='+productDetail : '')"
                class="btn btn-features mt-3"
                style="width: 100%;"
              >{{$t("banner.button_text")}}</a>

              <div class="pt-2" style="text-align: center; width: 100%" v-if="enableTrustpilot">
                <div style="display: inline-block;">
                  <small><b>{{this.$t('TRUSTPILOT_EXCELLENT')}}</b></small>
<!--                  <a href="https://de.trustpilot.com/review/sternenhimmel-poster.de" target="_blank">-->
<!--                    <img src="../assets/images/stars.png" style="width:75px; display: inline-block; position:relative;" class="mx-2" />-->
<!--                    <img src="../assets/images/Trustpilot_logo.png" style="width:70px; display: inline-block; position:relative;" />-->
<!--                  </a>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row featurette banner-text-off">
      <div class="col-md-6">
        <h2 class="featurette-heading">
          <span class="text-muted"></span>
        </h2>
        <div class="heading-title">{{$t("banner.heading")}}</div>
        <div
          class="heading-title-default"
        >{{$t("banner.sub_heading", {kw: $route.query.kw ? $route.query.kw : kw})}}</div>
        <ul class="features">
          <li>{{$t("banner.list.one")}}</li>
          <li>{{$t("banner.list.two")}}</li>
          <li>{{$t("banner.list.three")}}</li>
        </ul>
        <div
          class="features-details"
        >{{$t("banner.paragraph", {kw: $route.query.kw ? $route.query.kw : kw})}}</div>
        <a
          :href="'https://' + editorUrl + '/new/' + (productDetail !== null ? '?productType='+productDetail : '')"
          class="btn btn-outline-primary btn-features mt-3"
        >{{$t("banner.button_text")}}</a>
        <div class="pt-2" style="text-align: center; width: 100%" v-if="enableTrustpilot">
          <div style="display: inline-block;">
            <small><b>{{this.$t('TRUSTPILOT_EXCELLENT')}}</b></small>
<!--            <a href="https://de.trustpilot.com/review/sternenhimmel-poster.de" target="_blank">-->
<!--              <img src="../assets/images/stars.png" style="width:75px; display: inline-block; position:relative;" class="mx-2" />-->
<!--              <img src="../assets/images/Trustpilot_logo.png" style="width:70px; display: inline-block; position:relative;" />-->
<!--            </a>-->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FullBanner",
  props: {
    productDetail: {
      type: String,
    },
  },
  data() {
    return {
      editorUrl: 'editor.' + process.env.VUE_APP_ROOT_DOMAIN,
      kw: process.env.VUE_APP_KW,
      baseLocale: process.env.VUE_APP_BASE_LOCALE,
      enableTrustpilot: (process.env.VUE_APP_ENABLE_TRUSTPILOT === '1'),
    };
  },
};
</script>